@if (user) {
  <div [ngClass]="{'is-menu-reduced': menuState.isReduced}" [classList]='getPlatform()' class="menu_topbar">
    <!-- ONLY MOBILE -->
    <div (click)="switchMenuMobileOpen()" class="menu_topbar-burger">
      <svg [ngClass]="{'is-active' : menuState.isMenuMobileOpened}" class="topbar-burger" viewBox="0 0 100 100"
        width="40">
        <path class="line top"
        d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20"></path>
        <path class="line middle" d="m 70,50 h -40"></path>
        <path class="line bottom"
        d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20"></path>
      </svg>
    </div>
    <div class="menu_topbar-logo" (click)="navigateToAccueil()">
      <img alt="" src="../../../../assets/images/logo/logo-small.svg">
    </div>
    <!-- END ONLY MOBILE -->
    <!-- ONLY DESKTOP -->
    <div class="menu_topbar-title">
      <div (click)="switchMenuReduce()" class="menu_topbar_icon-small">
        <i [ngClass]="{'icon-chevron-right': menuState.isReduced, 'icon-chevron-left': !menuState.isReduced}"
        class="icon"></i>
      </div>
      @if (individu != null) {
        <span>Bonjour {{individu.nom}} {{individu.prenom}}</span>
      }
    </div>
    <!-- END ONLY DESKTOP -->
    <div class="menu_topbar-content">
      <app-entites-dropdownlist class="is-desktop"></app-entites-dropdownlist>
      @if (menuItemPlanningTaches) {
        <app-menu-item-top [menuItem]="menuItemPlanningTaches" class="menu_topbar_content-icon"></app-menu-item-top>
      }
      @if (menuItemTaches) {
        <app-menu-item-top [menuItem]="menuItemTaches" class="menu_topbar_content-icon" (menuClicked)="afficherPopupTaches()"></app-menu-item-top>
      }
      @for (menuItem of menusDynamiques; track menuItem) {
        <app-menu-item-top [menuItem]="menuItem" class="menu_topbar_content-icon"></app-menu-item-top>
      }
      <app-menu-item-top-notifications class="menu_topbar_content-icon is-notification"></app-menu-item-top-notifications>
      @if (menuItemMonCompte) {
        <app-menu-item-top [menuItem]="menuItemMonCompte" class="menu_topbar_content-icon is-mon-compte"></app-menu-item-top>
      }
    </div>
  </div>
}

